export default {
  authenticated: false,
  shop: null,
  shopInfos: null,
  shopToken: null, // jwt
};
